let Swiper, Navigation, Grid, Pagination, SliderNavigationHelper;

export default class SliderExpertsTile {
    static inject(swiper, navigation, pagination, grid, sliderNavigationHelper) {
        Swiper = swiper;
        Navigation = navigation;
        Pagination = pagination;
        Grid = grid;
        SliderNavigationHelper = sliderNavigationHelper;
    }

    constructor(item) {
        // this.xMousePos = 0;
        // this.yMousePos = 0;
        // this.lastScrolledTop = 0;
        // this.lastControl = 'next';

        this.createSwiper(item);
    }

    createSwiper(item) {
        let swiperPagination = item.querySelectorAll('.swiper-pagination')[0];
        let expertTeaserSlideSwiperContainer  = item.querySelectorAll(".expertTeaserSlideSwiperContainer")[0];
        let next = item.querySelectorAll('.swiper-button-next')[0];
        let prev = item.querySelectorAll('.swiper-button-prev')[0];
        let expertsPerSlide  = expertTeaserSlideSwiperContainer.getAttribute('data-experts-per-slide');
        let swiperLayoutConfig;

        let snh = new SliderNavigationHelper();
        snh.addFollowMouseListener(next, prev, item);

        switch (expertsPerSlide) {
            case '1':
                swiperLayoutConfig = {
                    modules: [ Navigation, Pagination, Grid ],
                    watchOverflow: true,
                    pagination: {
                        el: swiperPagination,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev,
                    },
                    slidesPerView: 1,
                    grid: {
                        rows: 1,
                        fill: 'row',
                    },
                    slidesPerGroup: 1,
                    // spaceBetween: 40,
                    // breakpoints: {
                    //     //.5 ist wichtig um Sliderbug zu verhindern
                    //     1300.5: {
                    //         slidesPerView: 2,
                    //         grid: {
                    //             rows: 2,
                    //         },
                    //         slidesPerGroup: 4,
                    //     },
                    // }
                }
                break;

            case '4':
                swiperLayoutConfig = {
                    modules: [ Navigation, Pagination, Grid ],
                    watchOverflow: true,
                    pagination: {
                        el: swiperPagination,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev,
                    },
                    slidesPerView: 1,
                    grid: {
                        rows: 1,
                        fill: 'row',
                    },
                    slidesPerGroup: 1,
                    // spaceBetween: 40,
                    breakpoints: {
                        //.5 ist wichtig um Sliderbug zu verhindern
                        1300.5: {
                            slidesPerView: 2,
                            grid: {
                                rows: 2,
                            },
                            slidesPerGroup: 2,
                        },
                    }
                }
                break;
        }

        let swiper = new Swiper(expertTeaserSlideSwiperContainer, swiperLayoutConfig);
        this.swiper = swiper;
    }
}
